var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Keypress',{attrs:{"key-event":"keydown"},on:{"success":_vm.keyDown}})}
var staticRenderFns = []

export { render, staticRenderFns }